import produce from 'immer';

import {
  CHANGE_PASSWORD_FAILED,
  UPDATE_PROFILE_FAILED,
  UPDATE_STATUS,
} from 'actions/accountActions';

export const initialState = {
  updateError: null,
};

/* eslint-disable default-case, no-param-reassign */
const accountReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case UPDATE_PROFILE_FAILED:
      case CHANGE_PASSWORD_FAILED:
        draft.updateError = action.err;
        break;
      case UPDATE_STATUS:
        draft.updateError = null;
        break;
    }
  });

export default accountReducer;
